var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgForkdomLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 16,
    viewBox: "0 0 26 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.9515 8.02687C21.9515 5.58051 19.9995 3.59734 17.5915 3.59734L0.151369 3.59733L0.15137 0.0537109L17.5915 0.0537137C21.9259 0.0537144 25.4396 3.62342 25.4396 8.02687C25.4396 12.4303 21.9259 16 17.5915 16L0.151367 16L0.151369 6.25505H12.7955V9.79868L3.6394 9.79868L3.6394 12.4564L17.5915 12.4564C19.9995 12.4564 21.9515 10.4732 21.9515 8.02687Z",
    fill: "#1F202F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgForkdomLogo);
export default __webpack_public_path__ + "static/media/forkdom-logo.fd9ecdf7fef4e862af64f5ed5e561e3a.svg";
export { ForwardRef as ReactComponent };